"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function updateVariantSteady(params) {
    var abrState = params.abrState, metrics = params.metrics, setCurrentVariantIndex = params.setCurrentVariantIndex;
    var variants = abrState.variants;
    var bandwidthEstimate = metrics.bandwidthEstimate;
    // 10% under-utilisation, attempt to download content slightly faster than it will be consumed
    var customerBandwidthUsage = 0.9;
    var modifiedBandwidthEstimate = bandwidthEstimate * customerBandwidthUsage;
    var variantIndex;
    for (variantIndex = 0; variantIndex < variants.length; variantIndex++) {
        var variant = variants[variantIndex];
        if (variant.bandwidth <= modifiedBandwidthEstimate) {
            break;
        }
    }
    variantIndex = Math.min(variantIndex, variants.length - 1);
    setCurrentVariantIndex(variantIndex);
}
exports.default = updateVariantSteady;
//# sourceMappingURL=updateVariantSteady.js.map